<template>
  <VaNavbar class="app-layout-navbar py-2 px-0">
    <template #left>
      <div class="left">
        <Transition v-if="isMobile" name="icon-fade" mode="out-in">
          <VaIcon
            color="primary"
            :name="isSidebarMinimized ? 'menu' : 'close'"
            size="24px"
            style="margin-top: 3px"
            @click="isSidebarMinimized = !isSidebarMinimized"
          />
        </Transition>
        <RouterLink to="/" aria-label="Visit home page">
          <VuesticLogo />
        </RouterLink>
      </div>
    </template>
    <template #center>
      <VaInput
        v-model="search"
        class="app-navbar__search"
        placeholder="Поиск..."
        clearable
        aria-label="Поиск по админ-панели"
      >
        <template #prependInner>
          <VaIcon name="search" color="secondary" size="small" />
        </template>
      </VaInput>
    </template>
    <template #right>
      <AppNavbarActions class="app-navbar__actions" :is-mobile="isMobile" />
    </template>
  </VaNavbar>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useGlobalStore } from '../../stores/global-store';
import AppNavbarActions from './components/AppNavbarActions.vue';
import VuesticLogo from '../VuesticLogo.vue';

defineProps({
  isMobile: { type: Boolean, default: false },
});

const GlobalStore = useGlobalStore();
const route = useRoute();
const router = useRouter();

const { isSidebarMinimized } = storeToRefs(GlobalStore);
const search = ref(String(route.query.search || ''));
let searchTimeout: ReturnType<typeof setTimeout> | undefined;

watch(
  () => route.query.search,
  (value) => {
    const nextSearch = String(value || '');
    if (search.value !== nextSearch) {
      search.value = nextSearch;
    }
  },
);

watch(search, (value) => {
  clearTimeout(searchTimeout);
  searchTimeout = setTimeout(() => {
    const nextSearch = value.trim();
    const currentSearch = String(route.query.search || '');

    if (nextSearch === currentSearch) {
      return;
    }

    const query = { ...route.query };
    if (nextSearch) {
      query.search = nextSearch;
    } else {
      delete query.search;
    }

    router.replace({ name: route.name || undefined, params: route.params, query });
  }, 500);
});
</script>

<style lang="scss" scoped>
.va-navbar {
  z-index: 2;

  @media screen and (max-width: 950px) {
    .left {
      width: 100%;
    }

    .app-navbar__actions {
      display: flex;
      justify-content: space-between;
    }

    .app-navbar__search {
      max-width: 100%;
      width: calc(100vw - 9rem);
    }
  }
}

.app-navbar__search {
  width: min(30rem, 42vw);
}

.left {
  display: flex;
  align-items: center;
  margin-left: 1rem;

  & > * {
    margin-right: 1rem;
  }

  & > *:last-child {
    margin-right: 0;
  }
}

.icon-fade-enter-active,
.icon-fade-leave-active {
  transition: transform 0.5s ease;
}

.icon-fade-enter,
.icon-fade-leave-to {
  transform: scale(0.5);
}
</style>
